import RestClient from './../../service/rest-client';
import AdHocViewEnum from './adHocViewEnum';
import {Signal} from 'signals';
import moment from 'moment';

class Service {
    event = {
        onAdHocAccounts: new Signal(),
        onAdHocPackages: new Signal(),
        onAdHocShipments: new Signal(),
        onAdHocShipmentsByStatus: new Signal(),
        onAdHocOrders: new Signal(),
        onAdHocCoupons: new Signal(),
        onAdHocReferrals: new Signal(),
        onAdHocManualAccountBalance: new Signal(),
    };

    getEventSignal(viewType) {
        switch (viewType) {
            case AdHocViewEnum.ACCOUNT:
                return this.event.onAdHocAccounts
            case AdHocViewEnum.PACKAGE:
                return this.event.onAdHocPackages
            case AdHocViewEnum.SHIPMENT:
                return this.event.onAdHocShipments
            case AdHocViewEnum.SHIPMENTBYSTATUS:
                return this.event.onAdHocShipmentsByStatus
            case AdHocViewEnum.COUPON:
                return this.event.onAdHocCoupons
            case AdHocViewEnum.REFERRAL:
                return this.event.onAdHocReferrals
            case AdHocViewEnum.MANUALACCOUNTBALANCE:
                return this.event.onAdHocManualAccountBalance
        }
    }

    // start accounts without sent shipment code
    fetchAdHocReport(page, searchParams, viewType) {
        RestClient.isSessionActive();

        var queryParams = [], urlRequestEndPointString = "", urlRequestTemplate = "";
        page = page || 1;
        queryParams = this._generateQueryParamsList(page, searchParams, viewType);

        urlRequestEndPointString = this._getRequestEndPointString(viewType, false);
        urlRequestTemplate = urlRequestEndPointString + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            var page = data.page_number;
            var pageSize = data.page_size,
                offset = (page - 1) * pageSize;
            var pagingMetadata = {
                page: data.page_number,
                startIndex: offset + 1,
                endIndex: offset + pageSize,
                totalCount: data.total_count,
                pageCount: Math.max(Math.ceil(data.total_count / pageSize), 1),
                totalShipments: data.results.length > 0 ? data.results[0].totalShipmentCount : 0
            };
            data.pagingMetadata = pagingMetadata;

            switch (viewType) {
                case AdHocViewEnum.ACCOUNT:
                    if (data.results.length > 0) {
                        data.results = this.parseResultData(data.results, viewType);
                    }
                    this.event.onAdHocAccounts.dispatch(data);
                    break;
                case AdHocViewEnum.PACKAGE:
                    data.results = this.parseResultData(data.results, viewType);
                    this.event.onAdHocPackages.dispatch(data);
                    break;
                case AdHocViewEnum.SHIPMENT:
                    data.results = this.parseResultData(data.results, viewType);
                    this.event.onAdHocShipments.dispatch(data);
                    break;
                case AdHocViewEnum.SHIPMENTBYSTATUS:
                    data.results = this.parseResultData(data.results[0].shipmentBySourceList, viewType);
                    this.event.onAdHocShipmentsByStatus.dispatch(data);
                    break;
                case AdHocViewEnum.COUPON:
                    data.results = this.parseResultData(data.results, viewType);
                    this.event.onAdHocCoupons.dispatch(data);
                    break;
                case AdHocViewEnum.REFERRAL:
                    data.results = this.parseResultData(data.results, viewType);
                    this.event.onAdHocReferrals.dispatch(data);
                    break;
                case AdHocViewEnum.MANUALACCOUNTBALANCE:
                    data.results = this.parseResultData(data.results, viewType);
                    this.event.onAdHocManualAccountBalance.dispatch(data);
            }
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    downloadAdHocReport(searchParams, viewType) {
        RestClient.isSessionActive();
        var queryParams = [], urlRequestTemplate = "" , urlRequestEndPointString = "";

        queryParams = this._generateQueryParamsList(0, searchParams, viewType);
        urlRequestEndPointString = this._getRequestEndPointString(viewType, true);

        if (queryParams.length > 0) {
            urlRequestTemplate = urlRequestEndPointString + "?" + queryParams.join("&");
            RestClient.downloadFile(urlRequestTemplate, true);
        } else {
            urlRequestTemplate = urlRequestEndPointString;
            RestClient.downloadFile(urlRequestTemplate, false);
        }
    }

    parseResultData(resultData, viewType) {
        var self = this;
        var parsedArray = resultData.map(function(dataItem) {
            var parsedObject = dataItem;

            if (viewType === AdHocViewEnum.ACCOUNT) {
                parsedObject.createdDate = moment(dataItem.createdDate).format("L");
            } else if (viewType === AdHocViewEnum.PACKAGE) {
                parsedObject.dateReceived = moment(dataItem.dateReceived).format("L");
                parsedObject.dateCreated = moment(dataItem.dateCreated).format("L");
                parsedObject.shelfSpace = dataItem.shelfSpaces.join();
                parsedObject.packageType = self._getPackageType(dataItem.packageTypeId);
            } else if (viewType === AdHocViewEnum.SHIPMENT) {
                parsedObject.serviceLevel = dataItem.serviceLevel != null ? dataItem.serviceLevel.name : '';
                parsedObject.numberPackages = dataItem.packages != null ? dataItem.packages.length : 0;
            } else if (viewType === AdHocViewEnum.SHIPMENTBYSTATUS) {
                if (dataItem.createdDate != null) {
                    parsedObject.createdDate = moment(dataItem.createdDate).format("L");
                } else {
                    parsedObject.changedByAccountId = dataItem.changedByAccountId;
                }

                //parsedObject.shipments = dataItem.shipmentBySourceList.shipments
            } else if (viewType === AdHocViewEnum.COUPON) {
                parsedObject.createdDate = moment(dataItem.createdDate).format("L");

                if (dataItem.startDate != null)
                    parsedObject.startDate = moment(dataItem.startDate).format("L");
                else
                    parsedObject.startDate = "";

                if (dataItem.expirationDate != null)
                    parsedObject.expirationDate = moment(dataItem.expirationDate).format("L");
                else
                    parsedObject.expirationDate = "";

            } else if (viewType === AdHocViewEnum.REFERRAL) {
                parsedObject.createdDate = moment(dataItem.createdDate).format("L");
                parsedObject.redeemedDate = dataItem.redeemedDate != null ? moment(dataItem.redeemedDate).format("L") : "";
            }

            return parsedObject;
        });
        return parsedArray;
    }

    // private
    _generateQueryParamsList(page, searchParams, viewType) {
        var queryParams = [];

        if (page !== 0) {
            var page = page || 1, limit = 10, pageSize = 10,
                offset = (page - 1) * pageSize;
            queryParams.push(`limit=${ limit }`);
            queryParams.push(`offset=${ offset }`)
        }

        if (searchParams.createdDateStart) {
            queryParams.push(`created_date_start=${ searchParams.createdDateStart }`)
        }

        if (searchParams.createdDateEnd) {
            queryParams.push(`created_date_end=${ searchParams.createdDateEnd }`)
        }

        if (searchParams.openSearch) {
            queryParams.push(`search_query=${ searchParams.openSearch }`)
        }

        if (searchParams.searchStatus) {
            queryParams.push(`status=${ searchParams.searchStatus }`)
        }

        if (searchParams.packageType) {
            queryParams.push(`packageType=${ searchParams.packageType }`)
        }

        if (searchParams.languagePreference) {
            queryParams.push(`language_preference=${ searchParams.languagePreference }`)
        }

        if (searchParams.countryDropdownValue) {
            queryParams.push(`search_country_code=${ searchParams.countryDropdownValue }`)
        }

        if (searchParams.searchWithOrWithoutShipments) {
            queryParams.push(`search_with_sent_shipment=${ searchParams.searchWithOrWithoutShipments }`)
        }

        if (viewType === AdHocViewEnum.PACKAGE) {
            queryParams.push(`include_if_in_shipment=${ true }`);
            queryParams.push(`include_if_consolidated=${ true }`);
        }

        if (viewType === AdHocViewEnum.REFERRAL) {
            queryParams.push(`search_account_id=${ searchParams.searchAccountId }`);
        }

        if (searchParams.shipDateStart) {
            queryParams.push(`shipped_date_start=${ searchParams.shipDateStart }`)
        }

        if (searchParams.shipDateEnd) {
            queryParams.push(`shipped_date_end=${ searchParams.shipDateEnd }`)
        }

        if (searchParams.groupBy) {
            queryParams.push(`group_by=${ searchParams.groupBy }`)
        }

        if (searchParams.searchUpdaterId) {
            queryParams.push(`updater_account_id=${ searchParams.searchUpdaterId }`)
        }

        if (searchParams.searchUserId) {
            queryParams.push(`user_account_id=${ searchParams.searchUserId }`)
        }

        return queryParams;
    }

    _getPackageType(packageTypeId) {
        switch (packageTypeId) {
            case 1:
                return "Package";
            case 2:
                return "Consolidated Package";
            case 3:
                return "Prohibited Package";
            default:
                return "";
        }
    }

    _getRequestEndPointString = (viewType, excelReport) => {
        switch (viewType) {
            case AdHocViewEnum.ACCOUNT:
                return "/reporting/adhoc/accounts".concat(excelReport ? "/file" : "?");
            case AdHocViewEnum.PACKAGE:
                return "/reporting/adhoc/packages".concat(excelReport ? "/file" : "?");
            case AdHocViewEnum.SHIPMENT:
                return "/reporting/adhoc/shipments".concat(excelReport ? "/file" : "?");
            case AdHocViewEnum.SHIPMENTBYSTATUS:
                return "/reporting/adhoc/shipments-by-status".concat(excelReport ? "/file" : "?");
            case AdHocViewEnum.COUPON:
                return "/reporting/adhoc/coupons".concat(excelReport ? "/file" : "?");
            case AdHocViewEnum.REFERRAL:
                return "/reporting/adhoc/referrals".concat(excelReport ? "/file" : "?");
            case AdHocViewEnum.MANUALACCOUNTBALANCE:
                return "/reporting/adhoc/manual-account-balance".concat(excelReport ? "/file" : "?");
            default:
                return ""
        }
    }
} export default new Service();
